import cx from 'classnames';
import React from 'react';
import { CheckCircleFilled, CloseCircleFilled, InfoCircleFilled, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = 'pen-result';
var iconRecord = {
  success: CheckCircleFilled,
  error: CloseCircleFilled,
  info: InfoCircleFilled,
  waiting: ClockCircleFilled,
  warning: ExclamationCircleFilled
};
export var Result = function Result(props) {
  var status = props.status,
      title = props.title,
      description = props.description,
      icon = props.icon;

  if (!status) {
    return null;
  }

  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix, classPrefix + "-" + status)
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-icon"
  }, icon || /*#__PURE__*/React.createElement(iconRecord[status])), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-title"
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-description"
  }, description)));
};